import React from 'react';
import { Steps } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';
import './ProgressBar.css';

const { Step } = Steps;

function ProgressBar({ currentStep, totalSteps, stepTitle, onStepClick, steps: stepsProp }) {
  const { t } = useTranslation('onboarding');

  const defaultSteps = [
    { title: t('progressBar.defaultSteps.personalData'), description: t('progressBar.defaultSteps.personalDataDesc') },
    { title: t('progressBar.defaultSteps.academicInfo'), description: t('progressBar.defaultSteps.academicInfoDesc') },
    { title: t('progressBar.defaultSteps.professionalProfile'), description: t('progressBar.defaultSteps.professionalProfileDesc') },
    { title: t('progressBar.defaultSteps.availability'), description: t('progressBar.defaultSteps.availabilityDesc') },
    { title: t('progressBar.defaultSteps.review'), description: t('progressBar.defaultSteps.reviewDesc') }
  ];
  const steps = Array.isArray(stepsProp) && stepsProp.length > 0 ? stepsProp : defaultSteps;

  // Arco Steps usa índices 0-3, así que restamos 1
  const arcoCurrentIndex = currentStep - 1;

  const handleDirectStepClick = (arcoStepIndex) => {
    // Convertir de índice Arco (0-2) a nuestro sistema (1-3)
    const ourStepNumber = arcoStepIndex + 1;

    // Solo permitir ir a pasos anteriores o al paso actual
    if (ourStepNumber <= currentStep && onStepClick) {
      onStepClick(ourStepNumber);
    }
  };

  return (
    <div className="onboarding-progress-bar">
      <div className="progress-header">
        <h2 className="progress-title">
          {t('progressBar.stepOf', { current: currentStep, total: totalSteps, title: stepTitle })}
        </h2>
        <p className="progress-subtitle">
          {t('progressBar.subtitle')}
        </p>
      </div>

      <Steps
        key={`steps-${currentStep}`}
        current={arcoCurrentIndex}
        className="progress-steps"
        size="small"
      >
        {steps.slice(0, totalSteps).map((step, index) => {
          let stepStatus = 'wait';
          if (index < arcoCurrentIndex) {
            stepStatus = 'finish';
          } else if (index === arcoCurrentIndex) {
            stepStatus = 'process';
          }

          // Solo permitir click en pasos completados o actual
          const isClickable = (index + 1) <= currentStep;

          return (
            <Step
              key={index}
              title={step.title}
              description={step.description}
              status={stepStatus}
              onClick={isClickable ? () => handleDirectStepClick(index) : undefined}
              style={isClickable ? { cursor: 'pointer' } : {}}
            />
          );
        })}
      </Steps>
    </div>
  );
}

export default ProgressBar;
